export const boxShadow = {
  '1': '0px 2px 3px rgba(19, 0, 49, 0.1)',
  '2': '0px 4px 4px rgba(19, 0, 49, 0.2)',
  '3': '0px 4px 4px rgba(0, 0, 0, 0.25)'
}
